import React from 'react';
import { bool } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { Row, Col } from '@thd-olt-component-react/grid';
import './EndcapPlaceholder.scss';
import { TopBar } from './TopBar';

const EndcapPodPlaceholder = ({ placeholderPodNumber, placeholderTextNumber, screenSize }) => {

  if (screenSize === 'xs') {
    return [...Array(placeholderPodNumber)].map((_placeholder) => {
      return (
        <div className="endcap-placeholder-image">
          <Placeholder type="rect" height="100px" width="316px" />
        </div>
      );
    });
  }
  return [...Array(placeholderPodNumber)].map((_placeholder) => {
    return (
      <div>
        <Placeholder type="rect" height="151px" width="200px" />
        {[...Array(placeholderTextNumber)].map((__placeholder) => <Placeholder type="text" width="200px" />
        )}
      </div>
    );
  }
  );
};

const EndcapPlaceholder = (props) => {
  const { tabClick } = props;

  let PLACEHOLDER_TAB_NUM = null;
  let PLACEHOLDER_POD_NUM = null;
  let PLACEHOLDER_TEXT_NUM = null;
  let SCREEN_SIZE = null;
  let PLACEHOLDER_TITLE_HEIGHT = null;

  if (typeof window !== 'undefined') {
    const width = window.innerWidth;

    if (width > 0 && width <= 640) {
      PLACEHOLDER_TAB_NUM = 4;
      PLACEHOLDER_POD_NUM = 4;
      PLACEHOLDER_TEXT_NUM = 4;
      SCREEN_SIZE = 'xs';
      PLACEHOLDER_TITLE_HEIGHT = '50px';
    } else if (width >= 640 && width <= 1024) {
      PLACEHOLDER_TAB_NUM = 6;
      PLACEHOLDER_POD_NUM = 6;
      PLACEHOLDER_TEXT_NUM = 6;
      PLACEHOLDER_TITLE_HEIGHT = '50px';
    } else {
      PLACEHOLDER_TAB_NUM = 10;
      PLACEHOLDER_POD_NUM = 10;
      PLACEHOLDER_TEXT_NUM = 6;
      PLACEHOLDER_TITLE_HEIGHT = '90px';
    }
  }

  if (tabClick) {
    return (
      <Row>
        <Col xs="12" sm="12" md="12" lg="12" nopadding>
          <div className="endcap-placeholder-pods">
            <EndcapPodPlaceholder
              placeholderPodNumber={PLACEHOLDER_POD_NUM}
              placeholderTextNumber={PLACEHOLDER_TEXT_NUM}
              screenSize={SCREEN_SIZE}
            />
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col xs="12" sm="12" md="12" lg="12" nopadding>
        <TopBar gradientColors={['#F96302']} />
      </Col>
      <Col xs="12" sm="12" md="12" lg="12" nopadding>
        <div className="endcap-placeholder-title">
          <Placeholder type="rect" height={PLACEHOLDER_TITLE_HEIGHT} width="281px" />
        </div>
      </Col>
      <Col xs="12" sm="12" md="12" lg="12" nopadding>
        <div className="endcap-placeholder-tabs">{[...Array(PLACEHOLDER_TAB_NUM)].map((idx) => {
          return (<Placeholder type="rect" height="40px" width="200px" />);
        })}
        </div>
        <div className="endcap-placeholder-pods">
          <EndcapPodPlaceholder
            placeholderPodNumber={PLACEHOLDER_POD_NUM}
            placeholderTextNumber={PLACEHOLDER_TEXT_NUM}
            screenSize={SCREEN_SIZE}
          />
        </div>
      </Col>
    </Row>
  );
};

export { EndcapPlaceholder };

EndcapPlaceholder.propTypes = {
  tabClick: bool
};

EndcapPlaceholder.defaultProps = {
  tabClick: null
};